module.exports = __webpack_public_path__ + "static/media/Dual_8300.830b27d3.jpg";